import { BaseApiService } from '@/shared/api/services/base.service';
import type { UploadPolicy } from '@/types/project-reference';

export interface SupportAttachmentStoreResponse {
  data: {
    type: 'support-ticket-attachment';
    id: string;
    attributes: {
      file_id: string | null;
      file_url: string | null;
      upload_policy: UploadPolicy | null;
      original_file_name?: string | null;
    };
  };
}

interface CreateAttachmentBody {
  data: {
    type: 'support-ticket-attachment';
    attributes: {
      md5: string;
      file_name: string | null;
      content_type: string;
    };
  };
}

/**
 * API client for support-ticket-attachment endpoints. Pairs with the shared
 * ImageUploadService: the caller supplies `create` and `confirm` callbacks that
 * route through here to hit the support-ticket-attachment routes instead of
 * angle routes.
 */
class SupportAttachmentService extends BaseApiService {
  async create(params: {
    md5: string;
    fileName: string | null;
    contentType: string;
  }): Promise<SupportAttachmentStoreResponse> {
    const body: CreateAttachmentBody = {
      data: {
        type: 'support-ticket-attachment',
        attributes: {
          md5: params.md5,
          file_name: params.fileName,
          content_type: params.contentType,
        },
      },
    };

    return this.post<SupportAttachmentStoreResponse, CreateAttachmentBody>(
      '/v1/support-ticket-attachments',
      body
    );
  }

  async confirm(id: string): Promise<void> {
    await this.post<void, undefined>(
      `/v1/support-ticket-attachments/${id}/confirm`,
      undefined
    );
  }

  async remove(id: string): Promise<void> {
    await this.httpDelete<void>(`/v1/support-ticket-attachments/${id}`);
  }
}

export const supportAttachmentService = new SupportAttachmentService();
